import { baseUrl } from "../../constants";

const EventPicsData = [
  {
    id: 1,
    imgSrc: `/image/GloryImages/kavyanjali-photos/1.jpg`,
  },
  {
    id: 2,
    imgSrc: `/image/GloryImages/kavyanjali-photos/2.jpg`,
  },
  {
    id: 3,
    imgSrc: `/image/GloryImages/kavyanjali-photos/3.jpg`,
  },
  {
    id: 4,
    imgSrc: `/image/GloryImages/kavyanjali-photos/4.jpg`,
  },
  {
    id: 5,
    imgSrc: `/image/GloryImages/kavyanjali-photos/5.jpg`,
  },
  {
    id: 6,
    imgSrc: `/image/GloryImages/kavyanjali-photos/1.jpg`,
  },
  {
    id: 7,
    imgSrc: `/image/GloryImages/kavyanjali-photos/2.jpg`,
  },
  {
    id: 8,
    imgSrc: `/image/GloryImages/kavyanjali-photos/3.jpg`,
  },
  {
    id: 9,
    imgSrc: `/image/GloryImages/kavyanjali-photos/4.jpg`,
  },
  {
    id: 10,
    imgSrc: `/image/GloryImages/kavyanjali-photos/5.jpg`,
  },
];
const KavynjaliPicsData = EventPicsData;
const anchoringPicsData = [
  {
    id: 1,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (1).jpg`,
  },
  {
    id: 2,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (2).jpg`,
  },
  {
    id: 3,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (3).jpg`,
  },
  {
    id: 4,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (4).jpg`,
  },
  {
    id: 5,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (5).jpg`,
  },
  {
    id: 6,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (6).jpg`,
  },
  {
    id: 7,
    imgSrc: `/image/GloryImages/anchoring-photos/anchoring (a)nchoring (7).jpg`,
  },
];
const newKavynjaliPicsData = [
  {
    src: "/image/GloryImages/kavyanjali-photos/1.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/2.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/3.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/4.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/5.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/6.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/7.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/8.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/9.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/10.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/11.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "/image/GloryImages/kavyanjali-photos/12.jpg",
    width: 3,
    height: 4,
  },
];

const newAnchoringPicsData = [
  {
    src: "/image/GloryImages/anchoring-photos/anchoring (1).jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/anchoring-photos/anchoring (2).jpg",
    width: 8,
    height: 6,
  },
  {
    src: "/image/GloryImages/anchoring-photos/anchoring (3).jpg",
    width: 8,
    height: 4.5,
  },
  {
    src: "/image/GloryImages/anchoring-photos/anchoring (4).jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/anchoring-photos/anchoring (5).jpg",
    width: 4,
    height: 3,
  },
  {
    src: "/image/GloryImages/anchoring-photos/anchoring (6).jpg",
    width: 4,
    height: 3,
  },
];

const newEventPicsData = [];
const stagePicsData = [
  {
    src: "/image/GloryImages/stage-photos/stage (1).jpg",
    width: 1,
    height: 1,
  },
  {
    src: `/image/GloryImages/stage-photos/stage (2).jpg`,
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (3).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (4).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (5).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (6).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (7).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (8).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (9).jpg",
    width: 1,
    height: 1,
  },
  {
    src: "/image/GloryImages/stage-photos/stage (10).jpg",
    width: 1,
    height: 1,
  },
];

export {
  newEventPicsData,
  newKavynjaliPicsData,
  EventPicsData,
  KavynjaliPicsData,
  anchoringPicsData,
  newAnchoringPicsData,
  stagePicsData,
};
